import Bloc from './Bloc.js';
import Types from './Types.js';

export default class UseMana extends Bloc {

	constructor (src, ctx) {

		super("usemana", src, ctx, true);
		this.f = (src, ins) => {
			src.master.pay(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}